export default __webpack_public_path__ + "static/media/icone-pdf.7ff19b43.svg";